import { useUserContext } from '../context/UserContext';

/**
 * Hook to use the User Context API
 */
export const useUser = () => {
  const {
    user,
    isAuthenticated,
    loading,
    error,
    login,
    logout,
    updateUser,
    getUserId,
    getToken,
    clearError,
    firstName,
    lastName,
    email,
    name,
    phone,
    timezone,
  } = useUserContext();

  return {
    // User data
    user,
    isAuthenticated,
    loading,
    error,
    
    // User actions
    login,
    logout,
    updateUser,
    clearError,
    
    // Helper functions
    getUserId,
    getToken,
    
    // Convenience getters
    userId: getUserId(),
    token: getToken(),
    
    // User properties
    firstName,
    lastName,
    email,
    name,
    phone,
    timezone,
  };
};
